import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { Api } from "~/api";

import DeliveryMap from "..";

export default function ShopsMap({ isError, type }: any) {
  const { basket } = useSelector((state: any) => state.cart);
  const [isLoading, setIsLoading] = useState(false);

  const { contactsData } = useSelector((state: any) => state.contacts);

  const [delivery, setDelivery] = useState(null);

  const getDelivery = async () => {
    const data = await Api.server.getProductDelivery(
      basket?.ITEMS?.map((item: any) => item.PRODUCT_ID),
      contactsData?.SHOPS.map((item: any) => item.PROP_ID_NEW),
    );
    setDelivery(data);
  };

  useEffect(() => {
    if (basket.ITEMS?.length > 0) {
      getDelivery();
    }
  }, [basket]);

  const shopsFiltered = useMemo(() => {
    if (basket.ITEMS?.length === 0) {
      setIsLoading(true);
      return [];
    }
    if (contactsData?.SHOPS?.length > 0) {
      setIsLoading(false);
      return contactsData?.SHOPS.map((shop: any) => {
        let DEL_DAYS = -1;
        if (delivery) {
          Object.values(delivery)?.forEach((productDelivery: any) => {
            const currentShopDeliveryData = productDelivery.find(
              (item: any) => item.id === shop.PROP_ID_NEW,
            );
            if (DEL_DAYS < currentShopDeliveryData.days) {
              DEL_DAYS = currentShopDeliveryData.days;
            }
          });
        }

        return {
          ...shop,
          DEL_DAYS,
          AVAL: DEL_DAYS > -1,
        };
      });
    }
    return [];
  }, [delivery, contactsData, type, basket]);

  const points = useMemo(() => {
    return shopsFiltered.map((item: any) => {
      return {
        ID: item.ID,
        AVAL: item.AVAL,
        NAME: item.NAME,
        TITLE: item.TITLE,
        WORK_TIME: item.WORK_TIME,
        PRICE: null,
        PRICE_DOP: null,
        DEL_DAYS: item.DEL_DAYS,
        GPS_N: item.GPS_N,
        GPS_S: item.GPS_S,
      };
    });
  }, [shopsFiltered]);

  return (
    <DeliveryMap isError={isError} points={points} isLoading={isLoading} />
  );
}
